import compact from "lodash/compact";
import debounce from "lodash/debounce";
import flatMap from "lodash/flatMap";
import { IEdge } from "yfiles";
import getGraphEdgeSources from "../nodeOrEdgeSourceDataHandling/getGraphEdgeSources";
export default (documentId, graphReadyRef, onChangeGraphModel, debounceWait) => debounce((sender, evt) => {
    var _a;
    if (!((_a = graphReadyRef.current) === null || _a === void 0 ? void 0 : _a.readyForListeners))
        return;
    if (evt.item instanceof IEdge) {
        const currentEdgesSource = compact(flatMap(sender.edges.toArray(), getGraphEdgeSources));
        onChangeGraphModel(documentId, { edgesSource: currentEdgesSource }, false);
    }
}, debounceWait);
